export default "__VITE_ASSET__BlW_ZDsn__"